export default "__VITE_ASSET__DpsAkTjd__"